export default "__VITE_ASSET__45256524__"